import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CabeceraRemitoViewModel, InsumoRemitoViewModel, PartidaRemitoViewModel, RemitosService, errorsCodes} from '@services/remitos-service';
import {MdSnackBar} from '@angular/material';
import * as moment from 'moment';
import { isString } from 'util';
@Component({
  selector: 'app-remitos-detail-page',
  templateUrl: './remitos-detail-page.component.html',
  styleUrls: ['./remitos-detail-page.component.scss', '../common/remitos-common-styles.scss']
})
export class RemitosDetailPageComponent implements OnInit {

  STATES = {LOADING: 'LO', READY: 'RE', ERROR: 'ERR', NODATA: 'NODA'};

  cabeceraRemito: Cabecera = {cliente: [], remito: []};
  productos: InsumoRemitoViewModel[] = []
  partidasRemito: PartidaRemitoViewModel[];

  cabeceraState = this.STATES.LOADING;
  productosState = this.STATES.LOADING;
  partidasState = this.STATES.LOADING;

  impresionState = this.STATES.READY;

  title = '';

  id = '';

  constructor(
    private route: ActivatedRoute,
    private remitosService: RemitosService,
    private snackBar: MdSnackBar,
  ) {
    this.route.params.take(1).subscribe(params => {
      const id = this.route.snapshot.params['id'];
      this.id = id;
      if (id) {
        // --------------- CABECERA -------------------
        this.remitosService.getCabeceraRemito(id).take(1).subscribe((cabeceraRemito) => {
          if (cabeceraRemito.DocumentoJDE) {
            this.cabeceraRemito = this.mapCabeceraValues(cabeceraRemito);
            this.cabeceraState = this.STATES.READY;
            this.title = cabeceraRemito.NumeroComprobante.toString();
            this.remitosService.getMotivo(cabeceraRemito.DocumentoJDE).subscribe(x => {
              if (x && x.length) {
                this.cabeceraRemito.remito.find(x => x.name === 'Motivo de generación').value = x;
              }
            })
          } else {
            this.cabeceraState = this.STATES.ERROR;
          }
        }, err => this.cabeceraState = this.STATES.ERROR);

        // -------------- PRODUCTOS -------------------
        this.remitosService.getRemito(id).take(1).subscribe(res => {
          if (res.length) {
            this.productos = res;
            this.productosState = this.STATES.READY;
          } else {
            this.productosState = this.STATES.NODATA;
          }
        }, err => this.productosState = this.STATES.ERROR);

        // --------------- PARTIDAS? -------------------
        this.remitosService.getPartidaRemito(id).take(1).subscribe((partidasRemito) => {
          if (partidasRemito.length > 0) {
            this.partidasRemito = partidasRemito;
            this.partidasRemito.forEach(x => {
              x.Vencimiento = x.Vencimiento && x.Vencimiento !== 'null' ? x.Vencimiento.split('-').reverse().join('-') : 'Vencimiento inválido'
            })
            this.partidasState = this.STATES.READY;
          } else {
            this.partidasState = this.STATES.NODATA;
          }
        }, err => this.partidasState = this.STATES.ERROR);
      } else {
        this.snackBar.open('No se ha ingresado un remito válido', '', {duration: 2000});
      }
    });
  }


  ngOnInit() {
  }

  mapCabeceraValues(data: CabeceraRemitoViewModel): Cabecera {
    const finalData: Cabecera = {remito: [], cliente: []};
    // remito
    finalData.remito.push({name: 'Número de referencia remito', value: data.DocumentoJDE.toString()})
    finalData.remito.push({name: 'Centro Emisor', value: data.CentroEmisor})
    finalData.remito.push({name: 'Número de comprobante', value: data.NumeroComprobante})
    finalData.remito.push({name: 'Número legal', value: data.NumeroLegal})
    finalData.remito.push({name: 'Fecha', value: moment(data.FechaRemito).format("DD/MM/YYYY")})
    finalData.remito.push({name: 'Tipo de factura', value: data.LetraComprobante})
    finalData.remito.push({name: 'Código Nro', value: data.Tipo})
    finalData.remito.push({name: 'Observación', value: data.Observacion || '-'});
    finalData.remito.push({name: 'Motivo de generación', value: '-'});
    finalData.remito.push({name: 'Numero de CAI', value: data.NroCAI || '-'});
    finalData.remito.push({name: 'Fecha Desde CAI', value: moment(data.FechaDesdeCAI, 'YYYY-MM-DD').format('DD/MM/YYYY') || '-'});
    finalData.remito.push({name: 'Fecha Hasta CAI', value: moment(data.FechaHastaCAI, 'YYYY-MM-DD').format('DD/MM/YYYY') || '-'});

    // cliente
    finalData.cliente.push({name: 'ID de Cliente', value: data.Cliente})
    finalData.cliente.push({name: 'Nombre', value: data.Nombre})
    finalData.cliente.push({name: 'CUIT', value: data.CUIT})
    finalData.cliente.push({name: 'Dirección', value: data.Direccion})
    finalData.cliente.push({name: 'Nro. de IIBB', value: data.NroIIBB})
    finalData.cliente.push({name: 'Cateogoría IVA', value: data.SituacionIVA})
    finalData.cliente.push({name: 'Provincia', value: data.ProvinciaCliente})

    return finalData;
  }

  imprimirRemito() {
    // esperamos a que finalice la impresion antes de intentar una nueva
    if (this.impresionState === this.STATES.LOADING) {return;}
    this.impresionState = this.STATES.LOADING
    this.remitosService.imprimirRemito(this.id).subscribe(res => {
          if(isString(res)){
            let message = 'Ocurrió un error al recuperar los datos para la impresión del remito: ';
            let errorsAsArray = res.split(',');
            let errors = errorsAsArray.map((code) => ` ${errorsCodes[code]}`)
            this.snackBar.open(message + errors)
            this.impresionState = this.STATES.READY
            return;
          }
          this.impresionState = this.STATES.READY
    }, err => {
      this.impresionState = this.STATES.READY
      this.snackBar.open('Ha ocurrido un error al imprimir el remito.')
    })
  }

}

interface SimpleObject {
  name: string,
  value: string,
}

interface Cabecera {
  remito: SimpleObject[];
  cliente: SimpleObject[];
}





// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/remitos-detail-page/remitos-detail-page.component.ts